import React from 'react';
import AccordionTitle from './accordionTitle';
import AccordionTitleRskn from './../change/buildProduct/accordionTitleRskn';
import { connect } from 'react-redux';
import { InHomeUtils } from './../../util/inhomeUtils';
import ProductContainer from './productContainer'
import { parentAccordionFocusAnimate, focusAnimation, removeUnSelectedManualOffers, removeFlashOffers } from './../../action/buildProduct';
import { Service } from './../../constants/actionType';
class specialOffersAccord extends React.PureComponent {
    constructor(props) {
        super(props);
        this.splOfferAccordionRef = React.createRef();
    }
    componentDidUpdate () {
        if (((!this.props.isSubOffer && this.props.buildProduct.focusParentAccordion) || (this.props.isSubOffer && this.props.buildProduct.focusAccordion && this.checkAccordionStatus())) && this.props.sploffer.isAccordionOpen) {
        if (this.splOfferAccordionRef) {
            parentAccordionFocusAnimate(this.props.dispatch);
            focusAnimation(this.splOfferAccordionRef.offsetTop - (this.props.isSubOffer ? 0 : 10));
            }
        }
    }
    checkAccordionStatus = () => {
        return (this.props.sploffer.isAccordionOpen && ((this.props.isDataOffer && !(this.props.buildProduct.internet.isSubAccordionOpen || this.props.buildProduct.router.isAccordionOpen || this.props.buildProduct.techsure.isAccordionOpen || this.props.buildProduct.fne.isAccordionOpen)) 
        || !(this.props.buildProduct.tv.isSubAccordionOpen || this.props.buildProduct.router.isAccordionOpen || this.props.buildProduct.vRoom.isAccordionOpen || this.props.buildProduct.recording.isAccordionOpen || this.props.buildProduct.dct.isAccordionOpen || this.props.buildProduct.channel.isAccordionOpen )))
    }

    render() {
        let DataOfferAccordionStatus = this.props.sploffer?.data?.subAccordionStatus ? this.props.sploffer?.data?.subAccordionStatus == 'added' ? 'completed' : this.props.sploffer?.data?.subAccordionStatus == 'required' ? 'action required' : this.props.sploffer?.data?.subAccordionStatus : "";
        let parentAccordionStatus = this.props.isSubOffer ? this.props.sploffer.subAccordionStatus : this.props.DataOffer ? DataOfferAccordionStatus : this.props.sploffer.accordionStatus;
        let products = "";
        let displayStyle = "";
        let accordionImageSrc ="";
        let accordionInnerContent = '';
        let accordionContent = '';
        let accordionDisplayStyle = (this.props.buildProduct.contract.contractType === '2YR' && this.props.sploffer.offerplans2YR !== undefined && this.props.sploffer.offerplans2YR !== null && this.props.sploffer.offerplans2YR.length > 1) || (this.props.buildProduct.contract.contractType  === 'MTM' && this.props.sploffer.offerplansMTM !== undefined && this.props.sploffer.offerplansMTM !== null && this.props.sploffer.offerplansMTM.length > 1) ? 'row padding-vert-zero bdr-b-black' : 'row padding-vert-zero bdr-b-black hide';
        let splPromoTitle = [];
        let promoOfferText = '';
        let promoTxt=[];
        let fcpPromoTxt='';
        let splOfferPrdDetail='';
        let selectedPrdDetail=[];
        let selectedServiceType='';
        if(this.props.sploffer.offerplansMTM!=null && this.props.sploffer.offerplansMTM.length===1 && InHomeUtils.isNotNull(this.props.sploffer.offerplansMTM.filter(p => p.BsOfferAttrValue === "SONY_PLAYSTATION_3MONTH")))
        {
            accordionDisplayStyle = 'row padding-vert-zero bdr-b-black';
        }
        if(this.props.isSubOffer){
            if(this.props.sploffer != null && this.props.buildProduct.sploffer.selectedProduct !== undefined  && this.props.buildProduct.sploffer.selectedProduct != null && 
                this.props.buildProduct.sploffer.selectedProduct.hasOwnProperty('offerAttrValue') &&  this.props.buildProduct.sploffer.selectedProduct.hasOwnProperty('offerAttr')) {
                   splOfferPrdDetail = this.props.buildProduct.sploffer.selectedProduct.offerAttrValue + '_' + this.props.buildProduct.sploffer.selectedProduct.offerAttr;
                } 
                else 
                {
                    if(this.props.sploffer != null && this.props.buildProduct.sploffer.selectedProduct !== undefined  &&  this.props.buildProduct.sploffer.selectedProduct != null && 
                   this.props.buildProduct.sploffer.selectedProduct.hasOwnProperty('BsOfferAttrValue') && this.props.buildProduct.sploffer.selectedProduct.hasOwnProperty('BsOfferAttr')) {
                       splOfferPrdDetail = this.props.buildProduct.sploffer.selectedProduct.BsOfferAttrValue + '_' + this.props.buildProduct.sploffer.selectedProduct.BsOfferAttr;
   
                   }
               }
               if(this.props.isDataOffer &&
                 InHomeUtils.isNotNull(this.props.buildProduct.internet)
                 && InHomeUtils.isNotNull(this.props.buildProduct.internet.selectedProduct)
                  && InHomeUtils.isNotNull(this.props.buildProduct.internet.selectedProduct.specialOffers)){
                selectedPrdDetail=this.props.buildProduct.internet.selectedProduct.specialOffers;
                selectedServiceType=Service.data;
               }
               else {
                   if(InHomeUtils.isNotNull(this.props.buildProduct.tv)
                   && InHomeUtils.isNotNull(this.props.buildProduct.tv.selectedProduct)
                    && InHomeUtils.isNotNull(this.props.buildProduct.tv.selectedProduct.specialOffers)){
                    selectedPrdDetail=this.props.buildProduct.tv.selectedProduct.specialOffers;
                    selectedServiceType=Service.video;
                   }  
                
               }
            let splOfferDetail=removeUnSelectedManualOffers(selectedPrdDetail, " ", selectedServiceType,splOfferPrdDetail);
            splOfferDetail=removeFlashOffers(splOfferDetail, selectedServiceType);
            if(InHomeUtils.isNotNull(splOfferDetail)){
                splOfferDetail.forEach(offer => { 
               if (InHomeUtils.isNotEmpty(offer.offerFor) && InHomeUtils.isNotEmpty(offer.OfferText) && offer.BsOfferAttrValue && offer.BsOfferAttrValue !== "SONY_PS5_ACQ_HS") {
                    
                if(this.props.lqState.runtimeKey.EnableBlackFridayOffers === "Y"){
                  if(offer.OfferText.indexOf("Stream TV") > 0){
                    promoOfferText = offer.OfferText; 
                  }
                }else{
                    promoOfferText = offer.OfferText; 
                }
                   splPromoTitle.push(promoOfferText);      
               }  
                  
           });
        }
            promoTxt = [...new Set([...splPromoTitle])];
            let exclusivepromoTxt= this.props.sploffer && this.props.buildProduct.sploffer.selectedProduct && this.props.buildProduct.sploffer.selectedProduct.OfferText && this.props.buildProduct.sploffer.selectedProduct.OfferText.toLowerCase().indexOf('fios') > -1;
             if(exclusivepromoTxt  && this.props.buildProduct.internet && this.props.buildProduct.internet.selectedProduct &&this.props.buildProduct.internet.selectedProduct.speedCode === '945')
             {
                 promoTxt=promoTxt.filter(o => o !== undefined && o !== null && typeof o === 'string' && ( o.toLowerCase().indexOf("disney") === -1));
             }
             else if(exclusivepromoTxt && this.props.buildProduct.internet && this.props.buildProduct.internet.selectedProduct  && this.props.buildProduct.internet.selectedProduct.speedCode === '941')
             {
    
                 promoTxt=promoTxt.filter(o => o !== undefined && o !== null && typeof o === 'string' && ( o.toLowerCase().indexOf("disney") === -1));
             }
            if (promoTxt.length > 0) {
               promoTxt.map((promo)=>{
                if(promo === "Sony Gaming Offer")
                {
                    promo = "Sony DualSense Wireless Controller PS5";
                }
                if(promo != ""){
                    fcpPromoTxt+=" and "+promo+" ";
                }
                }) 
           } 
        }
       
        let sony_check = this.props.buildProduct.sploffer.selectedProduct && this.props.buildProduct.sploffer.selectedProduct.offerAttrValue && (this.props.buildProduct.sploffer.selectedProduct.offerAttrValue === "SONYPULSE3D_WLS_HEADSET_ACQ_HS" || this.props.buildProduct.sploffer.selectedProduct.offerAttrValue === "SONYPULSE3D_WLS_HEADSET_ACQ" || this.props.buildProduct.sploffer.selectedProduct.offerAttrValue === "SONY_PS5_ACQ") ? true : false;
        let accordionTitle = this.props.lqState.runtimeKey?.isAllowXboxOffer == 'N' ? `${!this.props.isSubOffer ? 'Select your choice of a Special Offer' : `Special Offer: Select your choice of ${this.props.isDataOffer ? 'an Internet' : 'a TV'} Offer`}` : 'A special gift, on us';
        let splOngoingDiscount = this.props.buildProduct.sploffer.offerplansMTM.filter((offer => offer.OfferText.indexOf('$20 Special Ongoing Discount') > -1 )) || [];
            splOngoingDiscount = splOngoingDiscount.length > 0 ? true : false;
        let ongoingDiscountOffer = this.props?.buildProduct?.sploffer?.selectedProduct?.OfferText?.indexOf('$20 Special Ongoing Discount') > -1 ? true : false;
        if (this.props.buildProduct.sploffer && this.props.buildProduct.sploffer.selectedProduct && this.props.buildProduct.sploffer.selectedProduct.OfferText && this.props.buildProduct.sploffer.selectedProduct.OfferText !== '') {
            accordionTitle = `${this.props.isSubOffer && this.props.isDataOffer && this.props.lqState.runtimeKey?.isAllowXboxOffer == 'N' ? 'Internet Offer: ' : ''} ${ sony_check? "Sony Gaming Offer" : this.props.buildProduct.sploffer.selectedProduct.OfferText.indexOf("and Samsung Galaxy Buds") > -1 ? this.props.buildProduct.sploffer.selectedProduct.OfferText.replace("and Samsung Galaxy Buds","") : 'A special gift, on us'} ${(splOngoingDiscount && !ongoingDiscountOffer)  ? fcpPromoTxt :'' }`;
        }

        let productList = this.props.buildProduct?.contract?.contractType === 'MTM' ? this.props.sploffer?.offerplansMTM.filter(offer=> offer.id !="R4139") : this.props.sploffer?.offerplans2YR.filter(offer=> offer.id !="R4139");
        
        productList = Array.isArray(productList) ? [...productList].sort((a, b) => Number(a?.Rank) - Number(b?.Rank)) : productList;

        function findNestedObj(entireObj, keyToFind, valToFind) {
            let foundObj;
            JSON.stringify(entireObj, (_, nestedValue) => {
              if (nestedValue && nestedValue[keyToFind] === valToFind) {
                foundObj = nestedValue;
              }
              return nestedValue;
            });
            return foundObj;
          };

          let m2mPlans = this.props?.buildProduct?.internet?.m2mPlans

          let isR4093InProfile = findNestedObj(m2mPlans, 'USOCIOSC', "R4093")
          let isR4049InProfile = findNestedObj(m2mPlans, 'USOCIOSC', "R4049")
          let isR4047InProfile = findNestedObj(m2mPlans, 'USOCIOSC', "R4047")

          let isocVal=[]
          if (isR4093InProfile !== undefined ){
            isocVal = [isR4093InProfile]
          }
          else if (isR4049InProfile !== undefined ){
            isocVal = [isR4049InProfile]
          }
          else if (isR4047InProfile !== undefined ){
            isocVal = [isR4047InProfile]
          }

        let BFxBoxSeriesInProfile =
          this.props?.profileCart?.cartData?.[0]?.rewardOffers?.rewardOffers?.findIndex((val) => val?.promoId === "R4093") >-1 && isocVal;
        // let BFxBoxSeriesInProfile = this.props?.buildProduct?.sploffer?.offerplansMTM?.find(val=>val?.id === "R4140") !==undefined && [this.props?.buildProduct?.sploffer?.offerplansMTM?.find(val=>val?.id === "R4140")]
        let isBFxBoxSeriesInSplOffer = this.props?.buildProduct?.sploffer?.offerplansMTM?.findIndex((val) => val?.id === "R4093") > -1;

        let BFxBoxBundleInProfile =
          this.props?.profileCart?.cartData?.[0]?.rewardOffers?.rewardOffers?.findIndex((val) => val?.promoId === "R4049") >-1 && isocVal;
        let isBFxBoxBundleInSplOffer = this.props?.buildProduct?.sploffer?.offerplansMTM?.findIndex((val) => val?.id === "R4049") > -1;

        let BFNetmaxInProfile =
          this.props?.profileCart?.cartData?.[0]?.rewardOffers?.rewardOffers?.findIndex((val) => val?.promoId === "R4047") >-1 && isocVal;
        let isNetmaxInSplOffer = this.props?.buildProduct?.sploffer?.offerplansMTM?.findIndex((val) => val?.id === "R4047") > -1;

        let finalProdList = (isBFxBoxSeriesInSplOffer || isBFxBoxBundleInSplOffer || isNetmaxInSplOffer)
          ? [...productList]
          : BFxBoxSeriesInProfile?.length > 0
          ? [...BFxBoxSeriesInProfile, ...productList]
          : BFxBoxBundleInProfile?.length > 0 
          ? [...BFxBoxBundleInProfile, ...productList]
          : BFNetmaxInProfile?.length > 0
          ? [...BFNetmaxInProfile, ...productList]
          : [...productList];

        productList = Array.isArray(finalProdList)
          ? [...finalProdList]
          : Array.isArray(productList)
          ? [...productList]
          : productList;
       // if (this.props.sploffer.isAccordionOpen) {
            products = <ProductContainer products={productList} style={{ displayStyle }}
                selectedProduct={this.props.buildProduct.sploffer.selectedProduct !== null && this.props.buildProduct.sploffer.selectedProduct !== undefined && this.props.buildProduct.sploffer.selectedProduct.id !== '' ? this.props.buildProduct.sploffer.selectedProduct : ""}
                voiceTN={this.props.requestTN !== undefined && this.props.requestTN !== null && this.props.requestTN !== '' ? this.props.requestTN : ''} modalWindow={this.props.modalWindow} 
                visitId={this.props.visitId} buildProduct={this.props.buildProduct} lqState={this.props.lqState} firstBill={this.props.firstBill} dispatch={this.props.dispatch} isSubOffer = {true} isDataOffer = {this.props.isDataOffer} flowType={this.props.flowType} BFxBoxSeriesInProfile={BFxBoxSeriesInProfile} BFxBoxBundleInProfile={BFxBoxBundleInProfile} BFNetmaxInProfile={BFNetmaxInProfile} isBFxBoxSeriesInSplOffer={isBFxBoxSeriesInSplOffer} isBFxBoxBundleInSplOffer={isBFxBoxBundleInSplOffer}  isNetmaxInSplOffer={isNetmaxInSplOffer} />;
       // }
        //let accordionTitle=this.props.data.selectedProduct!==null && this.props.data.selectedProduct.id!==''?
        // (this.props.data.isAccordionOpen?"Special Offer: Select your choice of one offer below.":(this.props.data.selectedProduct.name||this.props.data.selectedProduct.prodName)):"Special Offer: Select your choice of one offer below.";
        accordionInnerContent = <div className="columns padding-all-zero">
                            <div className={`w_accordion borderTp ${(this.props?.buildProduct?.isECMNEnabled) ? 'w_accordionreskin' : ''}`} id="specialofferAccordionBlock">
                                <div className={(!this.props.isSpecialOfferAccordionDisabled ? "accordion_blocks padding-top-zero" : "accordion_blocks  padding-top-zero disabled") + (this.props.sploffer?.isAccordionOpen && this.props.lqState.runtimeKey.Enablebgspecialoffer == 'Y' ? " holiday-sploffer-bg" : "")}>
                                    {
                                        (this.props?.buildProduct?.isECMNEnabled) 
                                        ? <AccordionTitleRskn topLine={true} isHidePromo={this.props.sploffer.isAccordionOpen ? 'true' : 'false'} title={accordionTitle} inputelementRef={this.props.inputRef}
                                        name={this.props.isSubOffer ? this.props.isDataOffer ? 'toggle_data_splOffer_accor' : 'toggle_tv_splOffer_accor' : 'toggle_splOffer_accor'} status={parentAccordionStatus} isAccordionOpen={this.props.sploffer.isAccordionOpen}
                                        isDoflow={this.props.isDoflow}></AccordionTitleRskn>
                                        : <AccordionTitle topLine={true} isHidePromo={this.props.sploffer.isAccordionOpen ? 'true' : 'false'} title={accordionTitle} inputelementRef={this.props.inputRef}
                                        name={this.props.isSubOffer ? this.props.isDataOffer ? 'toggle_data_splOffer_accor' : 'toggle_tv_splOffer_accor' : 'toggle_splOffer_accor'} status={parentAccordionStatus} isAccordionOpen={this.props.sploffer.isAccordionOpen}
                                        isDoflow={this.props.isDoflow}></AccordionTitle>
                                    } 
                                    <div className={this.props.isSubOffer ? '' : `showPad ${(this.props?.buildProduct?.isECMNEnabled) ? 'showPadRskn' : ''}`}>
                                        <div data-reveal-content="zContractAndOffer" aria-hidden="false" className={this.props.sploffer.isAccordionOpen ? `row accordion_blocks-content m_post-offer ${this.props.isSubOffer ? '' : 'margin-vert-large'} contract-accordion-open ${(this.props?.buildProduct?.isECMNEnabled) ? '' : 'border-left border-right border-bottom bg-white-active'}` : `row accordion_blocks-content m_post-offer ${this.props.isSubOffer ? '' : 'margin-vert-large'} ${(this.props?.buildProduct?.isECMNEnabled) ? '' : 'border-left border-right border-bottom bg-white-active'} contract-accordion-close`}>
                                            <div className={`row padding-all-zero margin-all-zero ${(this.props?.buildProduct?.isECMNEnabled) ? 'active bdr-b-black orderigRsknMr' : ''}`}>
                                                <div className="columns padding-all-zero">
                                                    <div className={`w_accordion borderTp ${(this.props?.buildProduct?.isECMNEnabled) ? 'w_accordionreskin' : ''}`}>
                                                        <div className={`accordion_blocks padding-top-zero ${this.props.sploffer.isAccordionOpen ? 'open' : 'close'}`}>
                                                            <div className="row accordion_blocks-content" data-reveal-content="zInternetOptions" style={{ transition: 'opacity 300ms' }} hidden="">
                                                                {/* <div className="columns"> */}
                                                                    <div className="columns relative accordionChild">
                                                                        {accordionImageSrc}
                                                                        <div className="accordionTile">
                                                                            {products}
                                                                        </div>
                                                                    </div>
                                                                {/* </div>  */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

        if(this.props.isSubOffer) {
            let displayStyle = !this.props.isParentAccordionOpen;
            accordionContent = <div className={`row accordion_blocks-content ${(this.props?.buildProduct?.isECMNEnabled) ? '' : 'margin-vert-large border-left border-right border-bottom bg-white-active'}`} style={{ transition:'opacity 300ms', display:displayStyle?'none':''}} ref={(el) => this.splOfferAccordionRef = el}>
                                <div className={`row padding-all-zero margin-all-zero ${(this.props?.buildProduct?.isECMNEnabled) ? 'active bdr-b-black orderigRsknMr' : ''}`}>
                                {accordionInnerContent}
                                </div>
                            </div>
        }
        else {
            accordionContent = <div className={accordionDisplayStyle} ref={(el) => this.splOfferAccordionRef = el}>
                                    {accordionInnerContent}
                                </div>
        }
        
        return (
            <React.Fragment>
                {accordionContent}
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
  return {
    lqState: state.loopQual,
    appState: state.app,
    buildProductState: state.buildProduct,
    profileCart: state.profileCart,
  };
};

export default connect(mapStateToProps)(specialOffersAccord);